import { render } from "./MainMenu.vue?vue&type=template&id=21855cab"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"
script.render = render

export default script